@if (!!keycloak.authenticated) {
  <div class="flex flex-col md:flex-row flex-1">
    <!-- Sidebar Filters -->
    <aside
      class="w-full h-full md:w-64 bg-white shadow-md overflow-y-auto flex-shrink-0 border-gray-200 border-r"
    >
      <div class="px-3 py-2 border-b border-gray-200">
        <h2 class="text-base font-semibold text-gray-700 flex items-center gap-2">
          <i class="ri-filter-2-line text-primary"></i>
          Filters
        </h2>
      </div>
      <div class="px-3 py-2 space-y-2 overflow-y-auto h-full" (keyup.enter)="search()">
        <div class="space-y-1">
          <label
            class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
            for="application"
          >
            Application
          </label>
          <input
            [(ngModel)]="searchModel.application"
            class="w-full pl-3 pr-8 py-1 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white text-gray-900 placeholder-gray-500"
            placeholder="Search application..."
            name="application"
            id="application"
          />
        </div>
        <div class="space-y-1">
          <label
            class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
            for="consumer"
          >
            Consumer
          </label>
          @if (consumer && consumer.toUpperCase() !== 'AIRGATEWAY') {
            <input
              class="w-full pl-3 pr-8 py-1 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white text-gray-900 placeholder-gray-500"
              [value]="consumer"
              disabled
            />
          } @else {
            <input
              [(ngModel)]="searchModel.consumer"
              class="w-full pl-3 pr-8 py-1 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white text-gray-900 placeholder-gray-500"
              placeholder="Search consumer..."
              name="consumer"
              id="consumer"
            />
          }
        </div>
        <div class="space-y-1">
          <label
            class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
            for="agency"
          >
            Agency
          </label>
          <input
            [(ngModel)]="searchModel.agency"
            class="w-full pl-3 pr-8 py-1 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white text-gray-900 placeholder-gray-500"
            placeholder="Search agency..."
            name="agency"
            id="agency"
          />
        </div>
        <div class="space-y-1">
          <label
            class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
            for="agent"
          >
            Agent
          </label>
          <input
            [(ngModel)]="searchModel.agent"
            class="w-full pl-3 pr-8 py-1 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white text-gray-900 placeholder-gray-500"
            placeholder="Search agent..."
            name="agent"
            id="agent"
          />
        </div>
        <div class="space-y-1">
          <label
            class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
            for="provider"
          >
            Provider
          </label>
          <input
            [(ngModel)]="searchModel.provider"
            class="w-full pl-3 pr-8 py-1 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white text-gray-900 placeholder-gray-500"
            placeholder="Search provider..."
            name="provider"
            id="provider"
          />
        </div>
        <div class="space-y-1 relative">
          <label class="text-sm font-medium text-gray-700" for="method">Method</label>

          <input
            [(ngModel)]="searchModel.method"
            (input)="filterMethods()"
            (keydown)="onKeyDown($event)"
            (focus)="showOptions = true"
            (blur)="hideOptions()"
            autocomplete="off"
            class="w-full pl-3 py-1 pr-8 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white text-gray-900 placeholder-gray-500"
            placeholder="Search method..."
            name="method"
            id="method"
          />

          @if (showOptions && filteredMethods.length > 0) {
            <ul
              class="absolute z-10 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-64 overflow-auto"
            >
              @for (method of filteredMethods; let i = $index; track method) {
                <li
                  (mousedown)="selectOption(method)"
                  class="method-item px-3 py-1 text-sm cursor-pointer hover:bg-gray-100"
                  [ngClass]="{ 'active bg-gray-100': i === highlightedMethodIndex }"
                >
                  {{ method }}
                </li>
              }
            </ul>
          }
        </div>
        <div class="space-y-3">
          <div class="flex flex-wrap gap-x-4 gap-y-2 items-start">
            <div class="w-full">
              <label
                class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-base font-medium text-gray-700"
                for="statusAll"
              >
                Status
              </label>
            </div>

            <div class="flex items-center">
              <input
                type="radio"
                class="radio"
                id="statusAll"
                name="status"
                value=""
                [(ngModel)]="searchModel.status"
              />
              <label for="statusAll" class="ml-2 text-gray-700">All</label>
            </div>

            <div class="flex items-center ml-3">
              <input
                type="radio"
                class="radio"
                id="statusClean"
                name="status"
                value="clean"
                [(ngModel)]="searchModel.status"
              />
              <label for="statusClean" class="ml-2 text-gray-700">Clean</label>
            </div>

            <div class="flex items-center ml-3">
              <input
                type="radio"
                class="radio"
                id="statusWarnings"
                name="status"
                value="with_warnings"
                [(ngModel)]="searchModel.status"
              />
              <label for="statusWarnings" class="ml-2 text-gray-700">With warnings</label>
            </div>

            <div class="flex items-center ml-3">
              <input
                type="radio"
                class="radio"
                id="statusErrors"
                name="status"
                value="with_errors"
                [(ngModel)]="searchModel.status"
              />
              <label for="statusErrors" class="ml-2 text-gray-700">With errors</label>
            </div>

            <div class="flex items-center ml-3">
              <input
                type="radio"
                class="radio"
                id="statusPending"
                name="status"
                value="pending"
                [(ngModel)]="searchModel.status"
              />
              <label for="statusPending" class="ml-2 text-gray-700">Pending</label>
            </div>
          </div>
        </div>
        <div class="space-y-1">
          <label
            class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
            for="api_version"
          >
            API Version
          </label>
          <input
            [(ngModel)]="searchModel.api_version"
            class="w-full pl-3 pr-8 py-1 text-sm rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white text-gray-900 placeholder-gray-500"
            placeholder="Search version..."
            name="api_version"
            id="api_version"
          />
        </div>
        <div class="space-y-2 pt-1 border-t border-gray-200">
          <label
            class="peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm font-medium text-gray-700"
          >
            Date Range
          </label>
          <div class="space-y-2">
            <div class="space-y-1">
              <label
                class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm text-gray-600"
                for="date_from"
              >
                From
              </label>
              <div class="relative" [class.dropdown-open]="isDateFromPopoverOpen">
                <input
                  [(ngModel)]="searchModel.date_from"
                  type="date"
                  readonly
                  (click)="isDateFromPopoverOpen = !isDateFromPopoverOpen"
                  class="cursor-pointer w-full pl-4 pr-10 py-2 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white text-gray-900 placeholder-gray-500"
                  name="date_from"
                  id="date_from"
                />
                @if (isDateFromPopoverOpen) {
                  <div
                    class="dropdown-content text-center bg-base-100 rounded-box shadow-lg mt-2 p-2"
                  >
                    <calendar-date class="cally" (change)="onDateFromPicked($event)">
                      <svg
                        aria-label="Previous"
                        class="fill-current size-4"
                        slot="previous"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path d="M15.75 19.5 8.25 12l7.5-7.5"></path>
                      </svg>
                      <svg
                        aria-label="Next"
                        class="fill-current size-4"
                        slot="next"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path d="m8.25 4.5 7.5 7.5-7.5 7.5"></path>
                      </svg>
                      <calendar-month></calendar-month>
                    </calendar-date>
                  </div>
                }
              </div>
            </div>

            <div class="space-y-1">
              <label
                class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm text-gray-600"
                for="date_to"
              >
                To
              </label>
              <div class="relative" [class.dropdown-open]="isDateToPopoverOpen">
                <input
                  [(ngModel)]="searchModel.date_to"
                  type="date"
                  readonly
                  (click)="isDateToPopoverOpen = !isDateToPopoverOpen"
                  class="cursor-pointer w-full pl-4 pr-10 py-2 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/30 bg-white text-gray-900 placeholder-gray-500"
                  name="date_to"
                  id="date_to"
                />
                @if (isDateToPopoverOpen) {
                  <div class="dropdown-content bg-base-100 rounded-box shadow-lg mt-2 p-2">
                    <calendar-date class="cally" (change)="onDateToPicked($event)">
                      <svg
                        aria-label="Previous"
                        class="fill-current size-4"
                        slot="previous"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path d="M15.75 19.5 8.25 12l7.5-7.5"></path>
                      </svg>
                      <svg
                        aria-label="Next"
                        class="fill-current size-4"
                        slot="next"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                      >
                        <path d="m8.25 4.5 7.5 7.5-7.5 7.5"></path>
                      </svg>
                      <calendar-month></calendar-month>
                    </calendar-date>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div class="space-y-2 pt-1 border-t border-gray-200">
          <div class="flex items-center space-x-3">
            <input
              type="checkbox"
              class="checkbox"
              id="important"
              [checked]="searchModel.important"
              (change)="searchModel.important = !searchModel.important"
            />
            <label
              class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm text-gray-700"
              for="important"
            >
              Show Important
            </label>
          </div>
          <div class="flex items-center space-x-3">
            <input
              type="checkbox"
              class="checkbox"
              id="background"
              [checked]="searchModel.background"
              (change)="searchModel.background = !searchModel.background"
            />
            <label
              class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm text-gray-700"
              for="background"
            >
              Show Background Requests
            </label>
          </div>
          <div class="flex items-center space-x-3">
            <input
              type="checkbox"
              class="checkbox"
              id="anonymous"
              [checked]="searchModel.anonymous"
              (change)="searchModel.anonymous = !searchModel.anonymous"
            />
            <label
              class="font-medium peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-sm text-gray-700"
              for="anonymous"
            >
              Show Auth-Failed (Anonymous)
            </label>
          </div>
        </div>
        <div class="flex justify-center space-x-3 pt-3 pb-2 border-t border-gray-200">
          <button class="btn btn-sm" (click)="reset()">Reset</button>
          <button class="btn btn-sm btn-primary" (click)="search()">Search</button>
        </div>
      </div>
    </aside>
    @if (loaded) {
      <main class="flex-1 overflow-hidden">
        <div class="px-3 py-2 overflow-x-auto">
          <div class="flex items-center mb-2">
            <h1 class="text-base font-semibold">Home</h1>
            <div class="ml-auto flex space-x-2">
              <button
                class="btn btn-sm btn-outline"
                [ngClass]="{
                  'btn-info': !enableLiveUpdate,
                  'btn-error': enableLiveUpdate,
                }"
                (click)="toggleLiveUpdate()"
              >
                {{ enableLiveUpdate ? 'Disable' : 'Enable' }} Live Update
              </button>
              <button class="btn btn-sm btn-outline btn-info" (click)="currentPage = 0; search()">
                Refresh
              </button>
            </div>
          </div>
          <div class="overflow-x-auto bg-white shadow-md rounded-md">
            <table class="hidden md:table min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-100">
                <tr>
                  <th
                    class="w-1/8 px-2 py-1.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Consumer
                  </th>
                  <th
                    class="w-1/8 px-2 py-1.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Agency
                  </th>
                  <th
                    class="w-1/6 px-2 py-1.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Session ID
                  </th>
                  <th
                    class="w-1/8 px-2 py-1.5 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Num Req.
                  </th>
                  <!--
                    Status column = aggregate over the session's
                    requests via getSessionStatus (worst-of: error
                    > warning > ok > not_set). Same colour scale as
                    /search request rail and /search request card
                    pill. The whole row is tinted by the same status
                    so a quick eyeball over the table flags errors
                    without needing to read the column.
                  -->
                  <th
                    class="w-1/12 px-2 py-1.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Status
                  </th>
                  <th
                    class="w-1/8 px-2 py-1.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Created At
                  </th>
                  <th
                    class="w-1/4 px-2 py-1.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  ></th>
                  <th
                    class="w-1/8 px-2 py-1.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Last Activity
                  </th>
                  <th
                    class="w-1/8 px-2 py-1.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                @if (!preparedSessionData.length) {
                  <td colspan="9" class="text-center py-4 text-gray-500">
                    No sessions or requests found.
                  </td>
                }
                @for (
                  session of preparedSessionData
                    | paginate
                      : {
                          itemsPerPage: perPage,
                          currentPage: currentPage,
                          totalItems: sessionsCount,
                        };
                  track session.id;
                  let idx = $index
                ) {
                  <!--
                    Each session row is tinted by aggregate status
                    (worst-of its requests). Coloured rail (`border-l-4`
                    in the status colour) draws the eye to errors when
                    scanning the table. Same StatusInfo.tile classes
                    used as the request-tile background on /search.
                  -->
                  @let sessionStatus = session | getSessionStatus;
                  <tr
                    class="cursor-pointer border-l-4 transition"
                    [ngClass]="sessionStatus.tile"
                    (click)="isSessionVisible[idx] = !isSessionVisible[idx]"
                  >
                    <td class="px-2 py-1 truncate">
                      <div class="flex items-center">
                        <button
                          class="mr-2 text-gray-400 hover:text-gray-600 transform transition-transform duration-200"
                          [ngClass]="{
                            'rotate-0': isSessionVisible[idx],
                            'rotate-180': !isSessionVisible[idx],
                          }"
                        >
                          <i class="ri-arrow-up-s-line"></i>
                        </button>
                        <span class="text-sm font-medium text-gray-900 truncate">
                          {{ session | getConsumer }}
                        </span>
                      </div>
                    </td>
                    <td class="px-2 py-1 text-sm text-gray-900 truncate">
                      {{ session | getAgency }}
                    </td>
                    <td class="px-2 py-1 truncate">
                      <code
                        class="w-fit text-xs text-blue-600 hover:underline bg-blue-50 px-2 py-1 rounded truncate block"
                      >
                        <a
                          [routerLink]="['/search']"
                          [queryParams]="{ q: session.value }"
                          (click)="$event.stopPropagation()"
                        >
                          {{ session.value }}
                        </a>
                      </code>
                    </td>
                    <td class="px-2 py-1 text-right text-sm text-gray-700 tabular-nums">
                      {{ session.requests?.length || 0 }}
                    </td>
                    <td class="px-2 py-1">
                      <span
                        class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium"
                        [ngClass]="sessionStatus.pill"
                      >
                        {{ sessionStatus.label }}
                      </span>
                    </td>
                    <td class="px-2 py-1 text-xs text-gray-500 truncate">
                      {{ session.created_at | formatDate: 'request' }}
                    </td>
                    <td class="px-2 py-1 truncate"></td>
                    <td class="px-2 py-1 text-xs text-gray-500 truncate">
                      {{ session | sessionLastAction | formatDate: 'request' }}
                    </td>
                    <td class="px-2 py-1">
                      <a
                        class="btn btn-sm btn-primary"
                        [routerLink]="['/search']"
                        [queryParams]="{ q: session.value }"
                        (click)="$event.stopPropagation()"
                      >
                        <i class="ri-eye-line"></i>
                        Show
                      </a>
                    </td>
                  </tr>
                  @if (isSessionVisible[idx]) {
                    @for (request of session.requests; track request.id; let idx = $index) {
                      <!--
                        Per-request expanded rows inherit per-request
                        status (which can differ from the aggregate;
                        a 'warning' session can have ok children and
                        a single warning child below it).
                      -->
                      @let reqStatus = request | getStatus;
                      <tr class="border-l-4 transition" [ngClass]="reqStatus.tile">
                        <td class="px-2 py-1 text-sm text-gray-600"></td>
                        <td class="px-2 py-1 text-sm text-gray-600 truncate">
                          <!--
                            Per-request agent. Provider callbacks
                            (OrderChangeNotif) are pushed to us by the
                            airline and have no originating agent, so the
                            cell is left blank for them.
                          -->
                          @if (!(request | isProviderCallback)) {
                            {{ request.agent }}
                          }
                        </td>
                        <td class="px-2 py-1 text-sm text-gray-600 truncate">
                          {{ request.agency }}
                        </td>
                        <td class="px-2 py-1 pl-6 text-sm text-gray-600 truncate">
                          {{ request.method }}
                        </td>
                        <td
                          class="px-2 py-1 text-sm text-gray-600 max-w-[250px] break-words whitespace-normal"
                        >
                          <!--
                            request.provider can carry a verbatim
                            comma-separated list ("EK,CM,AV,…") when the
                            consumer-supplied Ag-Providers header
                            propagates through the sidecar. Render via
                            collapseProviders so multi-provider intent
                            shows as "*" — same convention as every
                            other Provider/Providers cell in the app
                            (request-details trace pills, session
                            summary line). Without this pipe the cell
                            spilled the full alphabet, breaking the
                            row layout reported on staging.
                          -->
                          <span [title]="request.provider">
                            {{ request.provider | collapseProviders }}
                          </span>
                        </td>
                        <td class="px-2 py-1">
                          <span
                            class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium"
                            [ngClass]="reqStatus.pill"
                          >
                            {{ reqStatus.label }}
                          </span>
                        </td>
                        <td class="px-2 py-1 text-sm text-gray-600">{{ request.application }}</td>
                        <td class="px-2 py-1 text-sm text-gray-600">
                          <code
                            class="w-fit text-xs text-blue-600 hover:underline bg-blue-50 px-2 py-1 rounded truncate block"
                          >
                            <a
                              [routerLink]="['/search']"
                              [queryParams]="{ q: request.request_id }"
                              (click)="$event.stopPropagation()"
                            >
                              {{ request.request_id }}
                            </a>
                          </code>
                        </td>
                        <td class="px-2 py-1 text-xs text-gray-500 truncate">
                          {{ request.created_at | formatDate: 'request' }}
                        </td>
                        <td class="px-2 py-1"></td>
                      </tr>
                    }
                  }
                  <tr class="h-1"></tr>
                }
              </tbody>
            </table>
            @for (
              session of preparedSessionData
                | paginate
                  : {
                      itemsPerPage: perPage,
                      currentPage: currentPage,
                      totalItems: sessionsCount,
                    };
              track session.id;
              let idx = $index;
              let first = $first
            ) {
              <div
                class="md:hidden divide-y divide-gray-200 mb-6 shadow"
                [ngClass]="{
                  'bg-white': idx % 2 === 0,
                  'bg-gray-50': idx % 2 !== 0,
                }"
                (click)="isSessionVisible[idx] = !isSessionVisible[idx]"
              >
                <div class="p-4">
                  <div class="flex justify-between items-center mb-2">
                    <span class="text-xs font-semibold text-gray-500">Consumer</span>
                    <span class="text-sm font-medium text-gray-900">
                      {{ session | getConsumer }}
                    </span>
                  </div>
                  <div class="flex justify-between items-center mb-2">
                    <span class="text-xs font-semibold text-gray-500">Agency</span>
                    <span class="text-sm text-gray-700">{{ session | getAgency }}</span>
                  </div>
                  <div class="flex justify-between items-center mb-2">
                    <span class="text-xs font-semibold text-gray-500 block">Session ID</span>
                    <a
                      class="text-sm text-primary"
                      [routerLink]="['/search']"
                      [queryParams]="{ q: session.value }"
                      (click)="$event.stopPropagation()"
                    >
                      {{ session.value }}
                    </a>
                  </div>
                  <div class="flex justify-between items-center mb-2">
                    <span class="text-xs font-semibold text-gray-500">Last Updated</span>
                    <span class="text-sm text-gray-500">
                      {{ session.updated_at | formatDate: 'request' }}
                    </span>
                  </div>
                  <a
                    class="btn btn-sm btn-primary w-full"
                    [routerLink]="['/search']"
                    [queryParams]="{ q: session.value }"
                    (click)="$event.stopPropagation()"
                  >
                    <i class="ri-eye-line"></i>
                    Show
                  </a>
                </div>

                @if (isSessionVisible[idx]) {
                  @for (request of session.requests; track request.id; let idx = $index) {
                    <div
                      class="border-l-4 bg-gray-25 hover:bg-gray-100 cursor-pointer p-4 space-y-2 border-l-primary"
                    >
                      @if (!(request | isProviderCallback)) {
                        <div class="flex justify-between items-center mb-2">
                          <span class="text-xs font-semibold text-gray-500">Agent</span>
                          <span class="text-sm text-gray-600">{{ request.agent }}</span>
                        </div>
                      }
                      <div class="flex justify-between items-center mb-2">
                        <span class="text-xs font-semibold text-gray-500">Method</span>
                        <span class="text-sm text-gray-600">{{ request.method }}</span>
                      </div>
                      <div class="flex justify-between items-center gap-5 mb-2">
                        <span class="text-xs font-semibold text-gray-500">Providers</span>
                        <span class="text-sm text-gray-600 truncate">
                          {{ request | getProviders }}
                        </span>
                      </div>
                      <div class="flex justify-between items-center mb-2">
                        <span class="text-xs font-semibold text-gray-500">Application</span>
                        <span class="text-sm text-gray-500">{{ request.application }}</span>
                      </div>
                      <div class="flex justify-between items-center mb-2">
                        <span class="text-xs font-semibold text-gray-500">Request ID</span>
                        <a
                          class="text-sm text-primary hover:underline"
                          [routerLink]="['/search']"
                          [queryParams]="{ q: request.request_id }"
                          (click)="$event.stopPropagation()"
                        >
                          {{ request.request_id }}
                        </a>
                      </div>
                      <div class="flex justify-between items-center mb-2">
                        <span class="text-xs font-semibold text-gray-500">Last Updated</span>
                        <span class="text-sm text-gray-500">
                          {{ request.created_at | formatDate: 'request' }}
                        </span>
                      </div>
                    </div>
                  }
                }
              </div>
            }

            @if (!preparedSessionData?.length) {
              <div
                class="md:hidden w-full text-center p-4 text-sm text-gray-500 border border-gray-200 rounded-md"
              >
                No sessions or requests found.
              </div>
            }

            @if (preparedSessionData?.length) {
              <!--
                Custom paginator: arrows-only. ngx-pagination's default
                <pagination-controls> renders numbered links — but the
                backend's pagination contract is "give me page N", with
                no global total. sessionsCount is a forward-looking
                approximation (= currentPage*perPage+1 while there's
                more, exact count when fewer than perPage land), so
                numbered links would imply a precision the data doesn't
                have. Prev/Next matches the actual UX.
              -->
              <pagination-template #p="paginationApi" (pageChange)="onPageChange($event)">
                <div class="mt-3 flex items-center justify-end gap-3">
                  <button
                    type="button"
                    class="btn btn-sm btn-outline btn-ghost"
                    [disabled]="p.isFirstPage()"
                    (click)="p.previous()"
                    title="Previous page"
                  >
                    <i class="ri-arrow-left-s-line"></i>
                    Previous
                  </button>
                  <span class="text-sm text-gray-500 font-mono tabular-nums">
                    Page {{ p.getCurrent() }}
                  </span>
                  <button
                    type="button"
                    class="btn btn-sm btn-outline btn-ghost"
                    [disabled]="p.isLastPage()"
                    (click)="p.next()"
                    title="Next page"
                  >
                    Next
                    <i class="ri-arrow-right-s-line"></i>
                  </button>
                </div>
              </pagination-template>
            }
          </div>
        </div>
      </main>
    } @else {
      <ngx-spinner color="#cd0005"></ngx-spinner>
    }
  </div>
} @else if (!selectedRealm) {
  <!--
    Unauthenticated landing — replaces the previous two giant
    "Login as Agent / Login as Admin" panels with a real product
    landing page: hero (logo + title + tagline), live aggregate
    stats from /stats, and a tabbed login affordance at the bottom.
  -->
  <div class="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 flex flex-col">
    <main class="flex-1 flex flex-col items-center px-6 py-12 md:py-16">
      <!-- Hero -->
      <section class="text-center max-w-3xl">
        <img
          ngSrc="assets/images/agw-logo.png"
          alt="AirGateway logo"
          class="mx-auto h-20 w-20 rounded-lg shadow-sm mb-6"
          height="80"
          width="80"
        />
        <h1 class="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 mb-3">
          AGW NDC
          <span class="text-primary">Tracer</span>
          App
        </h1>
        <p class="text-lg text-gray-600 max-w-2xl mx-auto">
          AGW's NDC Aggregation end-to-end Tracing tool
        </p>
      </section>

      <!-- Stats grid -->
      <section class="w-full max-w-2xl mt-12 md:mt-16">
        <div class="grid grid-cols-2 gap-4">
          <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-5 text-center">
            <div class="text-3xl md:text-4xl font-bold text-gray-900 tabular-nums">
              {{ stats ? (stats.sessions | number) : '—' }}
            </div>
            <div class="text-xs uppercase tracking-wider text-gray-500 mt-1">Sessions tracked</div>
          </div>
          <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-5 text-center">
            <div class="text-3xl md:text-4xl font-bold text-gray-900 tabular-nums">
              {{ stats ? (stats.requests | number) : '—' }}
            </div>
            <div class="text-xs uppercase tracking-wider text-gray-500 mt-1">Requests tracked</div>
          </div>
        </div>
      </section>

      <!-- Login: tabbed -->
      <section class="w-full max-w-md mt-12 md:mt-16">
        <div class="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden">
          <div class="grid grid-cols-2 border-b border-gray-200">
            <button
              type="button"
              class="px-4 py-3 text-sm font-medium transition"
              [ngClass]="
                loginTab === 'agents'
                  ? 'bg-white text-primary border-b-2 border-primary -mb-px'
                  : 'bg-gray-50 text-gray-600 hover:text-gray-900'
              "
              (click)="loginTab = 'agents'"
            >
              <i class="ri-user-line mr-1"></i>
              Agent
            </button>
            <button
              type="button"
              class="px-4 py-3 text-sm font-medium transition"
              [ngClass]="
                loginTab === 'admins'
                  ? 'bg-white text-primary border-b-2 border-primary -mb-px'
                  : 'bg-gray-50 text-gray-600 hover:text-gray-900'
              "
              (click)="loginTab = 'admins'"
            >
              <i class="ri-admin-line mr-1"></i>
              Admin
            </button>
          </div>
          <div class="p-6 text-center">
            <p class="text-sm text-gray-600 mb-4">
              @if (loginTab === 'agents') {
                Sign in with your agency account to view your traces.
              } @else {
                Sign in with an admin account to access all consumers.
              }
            </p>
            <button type="button" class="btn btn-primary w-full" (click)="selectRealm(loginTab)">
              Log in
            </button>
          </div>
        </div>
      </section>
    </main>
  </div>
}
